import {Form, Input, Spin} from "antd";
import "./style.less"
import {VALIDATION_MESSAGES} from "../../../../../enums/validationMessages";
import {FC} from "react";
import {LoginFormProps} from "../../../../../types/auth";
import {MailOutlined, LockOutlined} from "@ant-design/icons";

const LoginForm: FC<LoginFormProps> = (props) => {
  const {authController} = props
  const {authForm, loginHandler, isLoading} = authController
  return <Spin spinning={isLoading}>
    <Form className="login_form" layout="vertical" form={authForm} onFinish={loginHandler} disabled={isLoading}>
      <Form.Item name="email" label="Електронна пошта" rules={[
        {
          type: 'email',
          message: VALIDATION_MESSAGES.INVALID_EMAIL,
        },
        {
          required: true,
          message: VALIDATION_MESSAGES.REQUIRED,
        },
      ]}>
        <Input prefix={<MailOutlined/>} placeholder="name@example.com" autoComplete="username" inputMode="email" autoCapitalize="none"/>
      </Form.Item>
      <Form.Item name="password" label="Пароль" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <Input.Password prefix={<LockOutlined/>} placeholder="Введіть пароль" autoComplete="current-password"
                        onPressEnter={() => { if (!isLoading) authForm.submit() }}/>
      </Form.Item>
    </Form>
  </Spin>

}
export default LoginForm
